module.exports = __webpack_public_path__ + "static/media/bahai.fa560a18.svg";